/**
 * Supervision-related constants
 */

export const SUPERVISION_STATUS = {
  PENDING: 'pending' as const,
  APPROVED: 'approved' as const,
  REJECTED: 'rejected' as const,
} as const;

export const SUPERVISION_LOG_PREFIXES = {
  REVIEW: '[SUPERVISION_REVIEW]',
  SUBMIT: '[SUPERVISION_SUBMIT]',
  TASKS: '[SUPERVISION_TASKS]',
} as const;

export type SupervisionStatus =
  (typeof SUPERVISION_STATUS)[keyof typeof SUPERVISION_STATUS];
